module.exports = __webpack_public_path__ + "img/team_2.4156b948.png";